export const SET_LIST_MEMBERSHIP = "SET_LIST_MEMBERSHIP";
export const SET_NEW_LIST = "SET_NEW_LIST";
export const SET_LIST_MEMBERSHIP_STATE = "SET_LIST_MEMBERSHIP_STATE";
